<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    :close-on-click-modal="false"
  >
    <el-form
      ref="curdForm"
      :size="size"
      :rules="rules"
      :model="curdForm"
      label-position="right"
      label-width="100px"
    >
      <el-form-item label="模块编号：" prop="apiCode" class="details">
        <span>{{ curdForm.apiCode }}</span>
      </el-form-item>
      <el-form-item label="模块名称：" prop="apiName" class="details">
        <span>{{ curdForm.apiName }}</span>
      </el-form-item>
      <el-form-item label="模块类型：" prop="apiMenuType" class="details">
        <span>{{ curdForm.apiMenuType == 1 ? "按钮" : "模块" }}</span>
      </el-form-item>
      <el-form-item label="上级模块：" prop="parentApiName" class="details">
        <span>{{ curdForm.parentApiName }}</span>
      </el-form-item>
      <el-form-item label="模块url：" prop="apiUrl" class="details">
        <span>{{ curdForm.apiUrl }}</span>
      </el-form-item>
      <el-form-item label="创建人：" prop="userName" class="details">
        <span>{{ curdForm.userName }}</span>
      </el-form-item>
      <el-form-item label="创建时间：" prop="createDate" class="details">
        <span>{{ curdForm.createDate }}</span>
      </el-form-item>
      <el-form-item label="显示顺序：" prop="index" class="details">
        <span>{{ curdForm.index }}</span>
      </el-form-item>
      <el-form-item label="备注：" prop="remark" class="details">
        <span>{{ curdForm.remark }}</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn
        btntype="primary"
        title="关闭"
        @click.native="CUFlag = false"
      ></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus.js";
export default {
  components: { butn },
  data() {
    return {
      size: "small",
      curdTitle: "",
      CUFlag: false,
      Dflag: false,
      curdForm: {},
      status: [
        {
          value: 1,
          label: "启用"
        },
        {
          value: 0,
          label: "禁用"
        }
      ], //是否启用
      dataScope: [
        {
          value: 1,
          label: "全局"
        },
        {
          value: 0,
          label: "个人"
        }
      ], //数据范围
      rules: {}
    };
  },
  methods: {},
  mounted() {
    var _this = this;
    Bus.$on("details", function(item) {
      _this.curdTitle = "模块详情";
      _this.curdForm = item;
      _this.CUFlag = true;
    });
  }
};
</script>
